import { useState } from 'react';
import { FaClock, FaComment, FaEnvelope, FaMapMarkerAlt, FaPhone, FaUser, FaWhatsapp } from 'react-icons/fa';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);


    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitSuccess(true);


      alert('धन्यवाद! तपाईंको सन्देश पठाइयो। हामी चाँडै नै तपाईंसँग सम्पर्क गर्नेछौं।');


      setFormData({
        name: '',
        email: '',
        phone: '',
        message: ''
      });

      setTimeout(() => setSubmitSuccess(false), 5000);
    }, 1500);
  };

  return (
    <section className="contact-section" id="contact">
      <div className="container">
        <div className="contact-header">
          <h2 className="section-title">सम्पर्क गर्नुहोस्</h2>
          <p className="section-subtitle">हामीसँग जोडिनुहोस् र आफ्नो आवश्यकताको लागि उत्तम सेवा प्राप्त गर्नुहोस्</p>
        </div>

        <div className="contact-content">
          {/* Contact Information Sidebar */}
          <div className="contact-info">
            <div className="info-card">
              <div className="info-header">
                <h3>उग्रचण्डी आलु प्याज भण्डार </h3>
                <p className="info-tag">ताजा सब्जी वितरण</p>
              </div>

              <div className="info-details">
                <div className="info-item">
                  <div className="info-icon">
                    <FaMapMarkerAlt />
                  </div>
                  <div className="info-text">
                    <h4>ठेगाना</h4>
                    <p>कात्यायनी मार्ग, काठमाडौं</p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon">
                    <FaPhone />
                  </div>
                  <div className="info-text">
                    <h4>फोन नम्बर</h4>
                    <p className="phone-number">+९७७ ९८४९७५३५५७</p>
                    <p className="phone-number">+९७७ ९८५११९६०५६ </p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon">
                    <FaClock />
                  </div>
                  <div className="info-text">
                    <h4>समय</h4>
                    <p> ६:०० बिहान - ८:०० बेलुका</p>
                  </div>
                </div>

                <div className="info-item">
                  <div className="info-icon">
                    <FaWhatsapp />
                  </div>
                  <div className="info-text">
                    <h4>व्हाट्सएप सम्पर्क</h4>
                    <p>कुनै पनि प्रश्नको लागि व्हाट्सएपमा सम्पर्क गर्नुहोस्</p>
                    <p className="whatsapp-number"> ९८४९७५३५५७,९८५११९६०५६</p>
                  </div>
                </div>
              </div>

              <div className="contact-methods">
                <h4>सम्पर्क विधिहरू:</h4>
                <div className="method-list">
                  <div className="method-item">
                    <span className="method-icon">📞</span>
                    <span>फोन कल</span>
                  </div>
                  <div className="method-item">
                    <span className="method-icon">💬</span>
                    <span>व्हाट्सएप</span>
                  </div>
                  <div className="method-item">
                    <span className="method-icon">📧</span>
                    <span>इमेल</span>
                  </div>
                  <div className="method-item">
                    <span className="method-icon">🏪</span>
                    <span>सिधै स्टोरमा</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="contact-form-container">
            <div className="form-header">
              <h3>सन्देश पठाउनुहोस्</h3>
              <p>तपाईंको जिज्ञासा र आवश्यकताको लागि तुरुन्त सम्पर्क गर्नुहोस्</p>
            </div>

            <form onSubmit={handleSubmit} className={`contact-form ${submitSuccess ? 'success' : ''}`}>
              <div className="form-row">
                <div className="form-group">
                  <div className="input-icon">
                    <FaUser />
                  </div>
                  <input
                    type="text"
                    id="name"
                    placeholder="तपाईंको पूरा नाम"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                  <label htmlFor="name">पूरा नाम</label>
                </div>

                <div className="form-group">
                  <div className="input-icon">
                    <FaPhone />
                  </div>
                  <input
                    type="tel"
                    id="phone"
                    placeholder="९८४११२३४५६"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                  />
                  <label htmlFor="phone">फोन नम्बर</label>
                </div>
              </div>

              <div className="form-group">
                <div className="input-icon">
                  <FaEnvelope />
                </div>
                <input
                  type="email"
                  id="email"
                  placeholder="example@gmail.com"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
                <label htmlFor="email">इमेल ठेगाना</label>
              </div>

              <div className="form-group">
                <div className="input-icon textarea-icon">
                  <FaComment />
                </div>
                <textarea
                  id="message"
                  placeholder="तपाईंको सन्देश यहाँ लेख्नुहोस्..."
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="5"
                ></textarea>
                <label htmlFor="message">सन्देश</label>
              </div>

              <div className="form-actions">
                <button
                  type="submit"
                  className="submit-btn"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <>
                      <span className="spinner"></span>
                      पठाइदै...
                    </>
                  ) : (
                    'सन्देश पठाउनुहोस्'
                  )}
                </button>

                {submitSuccess && (
                  <div className="success-message">
                    <span className="success-icon">✓</span>
                    सन्देश सफलतापूर्वक पठाइयो!
                  </div>
                )}
              </div>
            </form>

            <div className="contact-notes">
              <div className="note">
                <span className="note-icon">💡</span>
                <p>थोक आर्डरको लागि कृपया फोन वा व्हाट्सएपमा सिधै सम्पर्क गर्नुहोस्</p>
              </div>
              <div className="note">
                <span className="note-icon">⏰</span>
                <p>सम्पर्क प्रति २४ घण्टा भित्र जवाफ दिने गरिन्छ</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;